/* Cart Notification Quick Add
   Custom file — survives theme updates.
   Re-link in snippets/cart-notification.liquid if lost. */

(function () {
  if (window.__quickAddInitialized) return;
  window.__quickAddInitialized = true;

  var activePicker = null;

  function parseSection(html) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('.shopify-section');
  }

  function closePicker() {
    if (activePicker) {
      activePicker.remove();
      activePicker = null;
    }
  }

  function addToCart(btn, variantId) {
    btn.disabled = true;
    var originalText = btn.textContent;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: ['cart-notification-items', 'cart-icon-bubble', 'cart-drawer']
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          btn.disabled = false;
          var link = btn.closest('.product-card-simple').querySelector('a');
          if (link) window.location.href = link.href;
          return;
        }

        btn.textContent = '✓';

        var cartItemEl = document.getElementById('cart-notification-item');
        if (cartItemEl && data.sections && data.sections['cart-notification-items']) {
          var section = parseSection(data.sections['cart-notification-items']);
          if (section) cartItemEl.innerHTML = section.innerHTML;
        }

        var bubbleEl = document.getElementById('cart-icon-bubble');
        if (bubbleEl && data.sections && data.sections['cart-icon-bubble']) {
          var bubble = parseSection(data.sections['cart-icon-bubble']);
          if (bubble) bubbleEl.innerHTML = bubble.innerHTML;
        }

        // Added from inside the cart drawer: re-render the drawer so the new
        // line appears (the theme's own renderContents handles it; the
        // recommendations block is re-populated by cart-drawer-recommend.js).
        var drawer = document.querySelector('cart-drawer');
        if (
          drawer &&
          drawer.hasAttribute('open') &&
          typeof drawer.renderContents === 'function' &&
          data.sections && data.sections['cart-drawer']
        ) {
          drawer.renderContents(data);
          return;
        }

        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        btn.disabled = false;
      });
  }

  function showPicker(btn, variants) {
    closePicker();

    var picker = document.createElement('div');
    picker.className = 'quick-add-variant-picker';
    picker.__triggerBtn = btn;

    variants.forEach(function (v) {
      var opt = document.createElement('button');
      opt.type = 'button';
      opt.className = 'quick-add-variant-option';
      opt.dataset.variantId = v.id;
      opt.textContent = v.title;
      if (!v.available) {
        opt.disabled = true;
        opt.classList.add('quick-add-variant-option--soldout');
      }
      picker.appendChild(opt);
    });

    document.body.appendChild(picker);
    activePicker = picker;

    var rect = btn.getBoundingClientRect();
    picker.style.bottom = (window.innerHeight - rect.top + 6) + 'px';
    picker.style.right = (window.innerWidth - rect.right) + 'px';
  }

  document.addEventListener('click', function (e) {
    // Variant option selected
    var opt = e.target.closest('.quick-add-variant-option');
    if (opt && activePicker) {
      e.preventDefault();
      e.stopPropagation();
      if (opt.disabled) return;
      var btn = activePicker.__triggerBtn;
      closePicker();
      if (btn) addToCart(btn, opt.dataset.variantId);
      return;
    }

    // Click outside picker
    if (!e.target.closest('.quick-add-variant-picker') && !e.target.closest('.product-card-simple__quick-add')) {
      closePicker();
    }

    // Quick add button clicked
    var btn = e.target.closest('.product-card-simple__quick-add');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;

    var variantsData = btn.dataset.variants;
    if (variantsData) {
      showPicker(btn, JSON.parse(variantsData));
      return;
    }

    addToCart(btn, btn.dataset.variantId);
  });

  // Close the picker when the user scrolls (it is position:fixed and would
  // otherwise stay detached from its button). Capture phase catches scrolling
  // inside the cart drawer/notification containers too.
  document.addEventListener('scroll', function () {
    closePicker();
  }, true);

  window.addEventListener('resize', closePicker);
})();

/* Cart drawer shipping estimate
   Shows the cheapest available shipping rate for the shopper's country in the
   cart drawer's shipping row, relabelled "Estimated shipping". Rates come from
   Shopify's own /cart/shipping_rates.json for the current cart, so they always
   match Settings > Shipping (thresholds, per-product profiles, market
   currency) with no numbers maintained here. Zones are flat-rate per country,
   so a fixed representative postcode per country returns that zone's rates.
   A fallback table covers a failed lookup; keep it roughly in step with
   Settings > Shipping (last checked 2026-09-10). Final cost still locks at
   checkout. */
(function () {
  if (window.__cartShipEstInit) return;
  window.__cartShipEstInit = true;

  var LABEL = 'Estimated shipping';

  // ISO country -> [postcode, province code]. Only countries with a shipping
  // zone; anything else leaves the theme's default text alone.
  var ADDRESS = {
    AU: ['2000', 'NSW'], NZ: ['1010', 'AUK'],
    AT: ['1010'], BE: ['1000'], CA: ['M5V 3L9', 'ON'], CZ: ['110 00'],
    DK: ['1050'], FI: ['00100'], FR: ['75001'], DE: ['10115'],
    IE: ['D02 X285', 'D'], IT: ['00100', 'RM'], NL: ['1011 AB'], NO: ['0150'],
    PL: ['00-001'], PT: ['1000-001', 'PT-11'], ES: ['28001', 'M'],
    SE: ['111 20'], CH: ['8001'], GB: ['SW1A 1AA', 'ENG'], US: ['90210', 'CA']
  };

  // Fallback only. Amounts in the zone's currency, thresholds likewise.
  var FALLBACK = {
    AU: { rate: 10.95, free: 150, currency: 'AUD' },
    NZ: { rate: 15, free: 150, currency: 'NZD' },
    INTL: { rate: 18, free: 200, currency: 'AUD' }
  };

  var cache = {};   // country|currency|total|items -> display text
  var inflight = null;

  function money(amount, currency) {
    return '$' + Number(amount).toFixed(2) + ' ' + currency;
  }

  function setText(el, text) {
    if (el && text && el.textContent.trim() !== text) el.textContent = text;
  }

  function fallbackText(country, cart) {
    var zone = FALLBACK[country] || (ADDRESS[country] ? FALLBACK.INTL : null);
    if (!zone) return null;
    var presRate = (window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    var totalInZone = cart.total_price / 100;
    if (cart.currency !== zone.currency) totalInZone = totalInZone / presRate;
    if (totalInZone >= zone.free) return 'FREE';
    var shown = cart.currency === zone.currency ? zone.rate : zone.rate * presRate;
    return money(shown, cart.currency);
  }

  function liveText(country, cart) {
    var addr = ADDRESS[country];
    if (!addr) return Promise.resolve(null);
    var qs = 'shipping_address[country]=' + encodeURIComponent(country) +
      '&shipping_address[zip]=' + encodeURIComponent(addr[0]) +
      (addr[1] ? '&shipping_address[province]=' + encodeURIComponent(addr[1]) : '');
    return fetch('/cart/shipping_rates.json?' + qs, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var rates = data && data.shipping_rates;
        if (!rates || !rates.length) return null;
        var cheapest = rates.reduce(function (a, b) {
          return parseFloat(b.price) < parseFloat(a.price) ? b : a;
        });
        var price = parseFloat(cheapest.price);
        if (!(price >= 0)) return null;
        return price === 0 ? 'FREE' : money(price, cheapest.currency || cart.currency);
      })
      .catch(function () { return null; });
  }

  function update() {
    var valEl = document.querySelector('.cart-drawer__footer .totals__shipping-value');
    if (!valEl) return;

    setText(document.querySelector('.cart-drawer__footer .totals__shipping'), LABEL);

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || cart.item_count === 0) return;
        var country = (window.Shopify && Shopify.country) || 'AU';
        var key = [country, cart.currency, cart.total_price, cart.item_count].join('|');

        if (cache[key]) { setText(valEl, cache[key]); return; }
        if (inflight === key) return;
        inflight = key;

        // Show the fallback straight away, then correct it with the live rate.
        setText(valEl, fallbackText(country, cart));

        liveText(country, cart).then(function (text) {
          if (inflight === key) inflight = null;
          if (!text) return;
          cache[key] = text;
          var el = document.querySelector('.cart-drawer__footer .totals__shipping-value');
          setText(el, text);
        });
      })
      .catch(function () {});
  }

  function init() {
    update();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var t;
      var obs = new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(update, 150);
      });
      obs.observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
